import { type LocationContent } from "@/components/location-page";
import { FEES, FIRM } from "@/lib/firm";

export const CONTENT: LocationContent = {
  slug: "moffat-beach",
  name: "Moffat Beach",
  title: "Moffat Beach conveyancing and wills lawyers",
  metaTitle: `Moffat Beach Conveyancing & Wills Lawyers | ${FIRM.name}`,
  description: `Fixed-fee Moffat Beach conveyancing — sales ${FEES.sale} incl. GST, purchases ${FEES.purchase}. Wills, EPOAs and estate administration. Local office in Golden Beach. Call ${FIRM.phone}.`,
  lead: "Moffat Beach mixes original post-war cottages, knock-down-rebuilds and small unit blocks. The contract risks change completely depending on which one you are buying.",
  paragraphs: [
    "We act for Moffat Beach buyers and sellers from our office at Golden Beach, a short drive away. Older houses here often carry unapproved work — decks, carports, sleepouts and studio conversions done long before anyone thought about approvals.",
    "If you are buying to renovate or rebuild, the building and development records matter more than the paint. We check what is approved, what is not, and who wears the risk after settlement.",
    "We also prepare wills and enduring powers of attorney for Moffat Beach residents and act for executors in local estates.",
  ],
  localNotes: [
    {
      t: "Unapproved building work",
      d: "Council building records will show what was approved. Unapproved decks, sheds and conversions become the buyer's problem — and the buyer's cost to rectify or certify.",
    },
    {
      t: "Character and demolition controls",
      d: "Some older dwellings are subject to planning controls affecting demolition or alteration. Confirm this before you commit to a knock-down-rebuild plan.",
    },
    {
      t: "Coastal hazard and flood overlays",
      d: "Erosion prone area, storm tide and overland flow overlays affect what you can build and what you will pay to insure. We read the planning search, not just the summary.",
    },
    {
      t: "Small unit blocks",
      d: "Two to six lot schemes often self-manage with thin sinking funds. Check levies, insurance and any deferred maintenance before you sign.",
    },
  ],
  suburbs: ["Dicky Beach", "Shelly Beach", "Kings Beach", "Caloundra", "Currimundi"],
  faqs: [
    {
      q: "How do I find out if a Moffat Beach deck or shed was approved?",
      a: "We obtain the council building and development records as part of the search package. If approvals are missing, you have options during the contract period — including requiring the seller to rectify or negotiating the price — that disappear once you settle.",
    },
    {
      q: "Is it worth buying an older house here to knock down and rebuild?",
      a: "Often, but confirm the planning overlays, any demolition controls, height and setback limits and coastal hazard mapping before you sign. A short pre-signing review is much cheaper than discovering the limits after settlement.",
    },
    {
      q: "How long does a standard Queensland contract take to settle?",
      a: "Typically 30 days from contract date, with building and pest and finance conditions usually falling due in the first two to three weeks. We diarise every date and remind you before each one.",
    },
  ],
};
